var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHbabyPaleBlueBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 899,
    height: 455,
    viewBox: "0 0 899 455",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560.63 59.6067C513.679 114.129 442.022 113.319 379.13 93.6732C278.356 62.1936 196.016 -24.1903 56.6618 120.043C-82.6927 264.277 68.9073 381.511 162.127 422.098C227.985 454.648 428.143 491.128 701.911 376.65C975.68 262.172 905.356 73.8069 831.631 20.1073C797.216 -4.95962 628.23 -18.8936 560.63 59.6067Z",
    fill: "#C0FFF6",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHbabyPaleBlueBg);
export default __webpack_public_path__ + "static/media/hbaby-paleBlue-BG.2b8c4cb15a934e07baac1b9116e40f15.svg";
export { ForwardRef as ReactComponent };